import axios from '../api/axios';

export async function login(email, password) {
  const response = await axios.post(
    '/login',
    JSON.stringify({
      email,
      password,
    }),
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );

  return response.data;
}
